import { getCalendarFolder } from '../selectors/calendarsCacheSelectors';
import { mutator } from 'satcheljs';
import { updateCalendarFolder } from '../actions/publicActions';

mutator(updateCalendarFolder, actionMessage => {
    const { calendar, calendarFolder } = actionMessage;

    const calendarFolderInStore = getCalendarFolder(calendar);

    Object.keys(calendarFolder).forEach(property => {
        calendarFolderInStore[property] = calendarFolder[property];
    });
});
